/**
 * The customer code for a "walkin" customer.
 *
 * @property WALKIN_CUSTOMER_CODE
 * @type {String}
 */
export const WALKIN_CUSTOMER_CODE = 'WALKIN'

/**
 * The length of the short code used for generating loyalty claim urls for a sale.
 *
 * @property SHORT_CODE_LENGTH
 * @type {Number}
 */
export const SHORT_CODE_LENGTH = 6

/**
 * Characters used to generate the short code for loyalty claim urls for a sale.
 *
 * @property SHORT_CODE_CHARS
 * @type {String}
 */
export const SHORT_CODE_CHARS =
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'

/**
 * The latest version of the Sale model. This is used to identify the state of the sale model and help migrate
 * old versions to the latest.
 *
 * @property SALE_VERSION
 * @type {Number}
 */
export const SALE_VERSION = 13

/**
 * The promo code added event name
 *
 * @property PROMO_CODE_ADDED
 * @type {String}
 * @deprecated Only used in angularJS footer, remove when footer migrated to react
 */
export const PROMO_CODE_ADDED = 'promo-code-added'

/**
 * The Heap Action name for when the line item fulfilment decision modal is viewed.
 */
export const HEAP_LINE_ITEM_FULFILMENT_DECISION_ACTION = 'View'

/**
 * The Heap Object name for the packaging breakdown option.
 */
export const HEAP_PACKAGING_BREAKDOWN_OPTION_OBJECT =
  'Packaging Breakdown Option'

/**
 * Minimum amount allowed by Stripe API
 */
export const MINIMUM_LSPAY_AMOUNT = 0.5

/**
 * The Heap Action name for delivery sale events.
 */
export const HEAP_DELIVERY_SALE_ACTION = 'delivery sale'

/**
 * The Heap Object name for when the delivery sale address is validated.
 */
export const HEAP_ADDRESS_VALIDATED_OBJECT = 'validated address'

/**
 * The Heap Object name for when the delivery sale address is not validated.
 */
export const HEAP_ADDRESS_NOT_VALIDATED_OBJECT = 'not validated address'

/**
 * The Heap Object name for when the delivery sale has no address.
 */
export const HEAP_NO_ADDRESS_OBJECT = 'no address'

/**
 * The Heap Object name for when autocomplete is used in address fields.
 */
export const HEAP_AUTOCOMPLETE_USED_OBJECT = 'address with autocomplete'

export const HEAP_DATA_TRACK_ADD_ADDRESS = 'add-address'
export const HEAP_DATA_TRACK_EDIT_ADDRESS = 'edit-address'
export const HEAP_DATA_TRACK_USE_BILLING_ADDRESS_FOR_SHIPPING =
  'use-billing-address-for-shipping'
export const HEAP_DATA_TRACK_UPDATE_BILLING_ADDRESS = 'update-billing-address'
